import React, { PureComponent } from "react";
import TwoColumnsLayout from "../../layouts/two-columns";
import ProductCostsChart from "../../../ceo/analysis/competitive/charts/product-costs";
import HelpIconButtonWithTooltipAndTypeformModal from "../../../typeform/HelpIconButtonWithTooltipAndTypeformModal";
import TypeformContent from "../../../typeform/TypeformContent";
import Teams from "../../../../api/Teams";

class TeamReportsSection5Step2 extends PureComponent {
  numberWithCommas = x => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  get left_content() {
    const team = Teams.currentTeam();
    const team_id = team ? team.id : 0;
    const unitsProduced = this.numberWithCommas(
      this.getDataValue(team_id, "Units Produced")
    );
    const avgUnitCost = this.getDataValue(team_id, "Average Unit Cost").toFixed(
      2
    );
    const { totalCosts } = this.props;

    return (
      <span>
        In this round, the Head of Operations produced {unitsProduced} units at
        a total production costs of $
        {this.numberWithCommas(totalCosts.toFixed(0))}, which resulted in
        product unit costs of ${avgUnitCost}. Your unit costs may vary if you
        have any inventory remaining from prior rounds.
        <br />
        <br />
        What drives your production costs?
      </span>
    );
  }

  getDataValue = (team_id, key) => {
    const { data } = this.props;

    if (!(team_id in data)) {
      return 0;
    }

    if (!(key in data[team_id])) {
      return 0;
    }

    return data[team_id][key] || 0;
  };

  get productCosts() {
    const { teams } = this.props;
    let data = [];

    Object.keys(teams).forEach(team_id => {
      data.push({
        team: teams[team_id],
        value: this.getDataValue(team_id, "Average Unit Cost")
      });
    });

    return data;
  }

  get right_content() {
    return (
      <div className="team-reports-valign-center">
        <h5>
          PRODUCT COSTS
          <HelpIconButtonWithTooltipAndTypeformModal
            iconSize="sm"
            {...TypeformContent.PRODUCT_COSTS}
          />
        </h5>
        <hr></hr>
        <div className="mt-15">
          <ProductCostsChart data={this.productCosts} />
        </div>
      </div>
    );
  }

  render() {
    return (
      <TwoColumnsLayout
        title="Operational Analysis"
        left_content={this.left_content}
        right_content={this.right_content}
      />
    );
  }
}

export default TeamReportsSection5Step2;



// WEBPACK FOOTER //
// ./src/components/team-reports/steps/section-5/step-2.js